const Player = () => import("../components/playerView.vue");


/* Exporting the object routes of player module. */
export default [
  {
    name: "player",
    path: "/player/:conversationId",
    meta: {
      Title: "Player",
      layout: "LoggedLayout",
      requireAuth: true
    },
    component: Player,
  },
];